<template>
  <div class="fade-in">
    <onboarding-loading
      v-if="isLoading"
      :loadingText="loadingMessage"
      :onErrorGoTo="'onboarding-error'"
    />

    <ContractView v-else :ccbUrl="myCCBUrl" @click="sendAcceptContract" />

    <GenericModal name="generic-modal" loadingText="Contrato Assinado" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ContractView from '../../../components/onboarding/ContractView.vue';
import GenericModal from '../../portal/components/Molecules/GenericModal.vue';
import OnboardingLoading from './OnboardingLoading.vue';

export default {
  name: 'onboarding-signature-contract-view',
  components: {
    ContractView,
    GenericModal,
    OnboardingLoading,
  },
  data() {
    return {
      isLoading: true,
      myCCBUrl: '',
      loadingMessage: 'Carregando contrato...',
    };
  },
  computed: {
    ...mapGetters('onboarding', ['ccbUrl']),
  },
  methods: {
    ...mapActions('onboarding', ['acceptContract']),
    async sendAcceptContract() {
      try {
        this.isLoading = true;
        await this.acceptContract();
        this.isLoading = false;

        this.$modal.show('generical-modal');
        this.handleNextStep();
      } catch {
        this.$router.replace({
          name: 'onboarding-error',
          query: this.$route.query,
        });
      }
    },
    handleNextStep() {
      setTimeout(() => {
        this.$modal.hide('generical-modal');
        this.$router.replace({
          name: 'onboarding-complete',
          query: this.$route.query,
        });
      }, 3000);
    },
  },
  async mounted() {
    try {
      const output = await fetch(`${this.ccbUrl}?returnUrl=true`);
      this.myCCBUrl = (await output.json()).url;
    } catch (err) {
      this.$router.replace({
        name: 'onboarding-error',
        query: this.$route.query,
      });
    }

    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
</style>
